<template>
  <div class="inventory-page">
	<Header></Header> <!-- 头部 -->
	<div class="content">
		<van-search
		  class="search-all"
		  id="js-search"
		  placeholder="请输入搜索关键词"
		  show-action
		  v-model="search_name"
		  @keyup="onInputShow('js-search')"
		>
			<div slot="action" @click="onSearch()">搜索</div>
		</van-search>
		
		<van-cell-group class="inventory-title">
		  <van-cell :title="'IPN: '+itemBaseInfo.NAME" :value="'P/L: '+itemBaseInfo.PRODUCTCATEGORYNAME" />
		</van-cell-group>
		<div class="tbl">
			<van-grid :column-num="1" class="tbl-th">
			  <van-grid-item text="ERP库存" />
			</van-grid>
			<van-row class="tbl-tr">
			  <van-col span="10">所在地</van-col>
			  <van-col span="4">数量</van-col>
			  <van-col span="4">所有者</van-col>
			  <van-col span="6">生产日期</van-col>
			</van-row>
			<van-row class="tbl-td">
			  <van-col span="10">HMA（虎门完税）</van-col>
			  <van-col span="4">30</van-col>
			  <van-col span="4">FREE</van-col>
			  <van-col span="6" class="look">
				  <van-cell @click="showPopup">查看详细</van-cell>
			  </van-col>
			</van-row>
			<van-row class="tbl-td">
			  <van-col span="10">总计：</van-col>
			  <van-col class="price" span="14">30</van-col>
			</van-row>
		</div>
		<van-popup :v-model="is_show">内容</van-popup>
		<div class="mt20">
			<van-collapse v-model="activeNames">
			  <van-collapse-item title="标题" name="1">
				<van-cell title="原厂物料" value="BL8573CS8TR" />
				<van-cell title="品牌" value="Belling" />
				<van-cell title="内部产品线" value="BEL" />
				<van-cell title="允许备货" value="Y" />
				<van-cell title="允许销售备货" value="N" />
				<van-cell title="S&D Part" value="Non-SSD Part" />
				<van-cell title="是否返款" value="Y" />
				<van-cell title="内部通用分类" value="FEW" />
				<van-cell title="原厂通用分类" value="Y" />
				<van-cell title="MPQ" value="2500" />
				<van-cell title="MOQ" value="2500" />
				<van-cell title="MIV" value="3000.000000" />
				<van-cell title="预警期" value="45" />
				<van-cell title="原厂标准交期" value="6W" />
				<van-cell title="原厂窗口期" value="30" />
				<van-cell title="NCNR物料" value="Y" />
				<van-cell title="NCNR协议及定金" value="" />
				<van-cell title="分货属性" value="" />
				<van-cell title="授权属性" value="" />
				<van-cell title="管制品分类" value="" />
				<van-cell title="最终用户声明" value="" />
				<van-cell title="EOL" value="" />
				<van-cell title="报关名称" value="" />
			  </van-collapse-item>
			</van-collapse>
		</div>
	</div>
  </div>
</template>
<script type="text/javascript">	
import axios from 'axios';
export default {
  data() {
    return {
	 is_show: false,
	 activeNames: ['1'],
	 search_name: "",
	 search_lists:[],
	 invInfoList:[],
	 itemBaseInfo:[],
	 poBackLogList:[]
	};
  },
  methods: {
	showPopup: function () {
	  this.is_show = true;
	},
	onInputShow: function (id) {
		axios.post(this.CoreNew.OA_API_IP+"joa-crm/crm/mobile/IntelliPrompt", {
		  apiType:"DataApi",fieldName:"InternalName",moduleName:"物料信息",of:"Crm_Srm_ProductCategoryId",q:this.search_name
		}).then(function (response) {
			console.log(response)
			var $rs=response.data;var str_html="";
			if($rs.flag==true){
				var $list=$rs.data;var _str_html
				for (var i = 0; i < $list.length; i++) {
					str_html +="<li data-val='"+$list[i].Name+"'>"+$list[i].Name.replace(this.search_name.toUpperCase(), "<span>"+this.search_name.toUpperCase()+"</span>")+"</li>";
				}
				$("#"+id).parent().find(".input_show").remove();
				$("#"+id).parent().append('<ul class="input_show">'+str_html+'</ul>');
				$("#"+id).parent().find(".input_show").show();
				var self = this;
				$("#"+id).parent().find(".input_show li").click(function(){
					self.search_name=$(this).attr("data-val");
					$("#"+id).parent().find(".input_show").hide();
				})
			}else{
				$("#"+id).parent().find(".input_show").html("");
				$("#"+id).parent().find(".input_show").hide();
			}
		}.bind(this)).catch(function (error) { 
			//alert("请求--存货查询--失败"+error);
			this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--存货查询--失败"+error);//记录错误
			console.log("请求--存货查询--失败"+error);
		});
	},
	onSearch: function () {
		if($("#js-search").val()== ''){ 
			this.$toast('关键字不能为空');
		}else{ 
			$(".search-all .van-search__action").html('<div class="van-loading van-loading--circular van-button__loading"><span class="van-loading__spinner van-loading__spinner--circular" style="color: currentcolor; width: 20px; height: 20px;"><svg viewBox="25 25 50 50" class="van-loading__circular"><circle cx="50" cy="50" r="20" fill="none"></circle></svg></span></div>');
			let post_data = new FormData();
			post_data.append('productCode',$("#js-search").val());
			post_data.append('loginUser',JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')));
			axios.post("http://10.1.100.172:8084/joa-crm/crm/mobile/InventoryInquiry",post_data).then(function (response) {
			//axios.post(this.CoreNew.OA_API_IP+"joa-crm/crm/mobile/InventoryInquiry",post_data).then(function (response) {
				var $rs=response.data;
				console.log($rs);
				if($rs.flag==true){
					this.invInfoList=$rs.data.invInfoList;
					this.itemBaseInfo=$rs.data.itemBaseInfo;
					this.poBackLogList=$rs.data.poBackLogList;
					//alert(this.search_lists.itemBaseInfo.PRODUCTCATEGORYNAME)
				}
				$(".search-all .van-search__action").html('<div>搜索</div>');
			}.bind(this)) 
			.catch(function (error) { 
			   $(".search-all .van-search__action").html('<div>搜索</div>');
			   //alert("请求--产品搜索--失败"+error);
			   this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--产品搜索--失败"+error);//记录错误
			   console.log("请求--产品搜索--失败"+error);
			});
		}
	}	
  }
};
</script>